import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import Carousel from './Carousel';

const NewsTab = ({ activeTab, handleTabChange, tabContent }) => {
    return (
        <Box sx={{ p: 2 }}>
            <Tabs
                value={activeTab}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="news tabs"
                sx={{
                    mb: 2,
                    '.MuiTabs-flexContainer': {
                        justifyContent: 'flex-start',
                        flexWrap: 'nowrap',
                    },
                    '.MuiTab-root': {
                        borderRadius: '3rem',
                        border: '1px solid transparent',
                        // backgroundColor: '#D7D9D7',
                        backgroundColor: 'rgba(235, 241, 244, 0.8)',
                        fontWeight: 'bold',
                        margin: 1,
                        '&.Mui-selected': {
                            backgroundColor: 'primary.main',
                            color: 'common.white',
                            fontWeight: 'bold',
                        },
                        '&:hover': {
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                        },
                    },
                    overflowX: 'auto',
                }}
            >
                {tabContent.map((tab, index) => (
                    <Tab key={index} label={tab.label} />
                ))}
            </Tabs>
            {tabContent.map((tab, index) => (
                <Box key={index} hidden={activeTab !== index}>
                    <Carousel content={tab.content} />
                </Box>
            ))}
        </Box>
    );
};

export default NewsTab;
